<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe ref="tableData">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="发票号码" prop="INVOICE_NUM" key="INVOICE_NUM"
            v-if="![0, 1, 2].includes(otherData.status)" width="120">
          </el-table-column>
          <el-table-column label="发票金额" prop="INVOICE_FEE" width="120" key="INVOICE_FEE"></el-table-column>
          <el-table-column label="客户名称" prop="COMPANY_NAME" key="COMPANY_NAME"></el-table-column>
          <el-table-column label="发票类型" width="80" key="INVOICE_TYPE">
            <template slot-scope="scope">
              <span>{{ invoiceTypeList[scope.row.INVOICE_TYPE - 1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发票摘要" prop="INVOICE_NAME" key="INVOICE_NAME"></el-table-column>
          <el-table-column label="发票内容" width="80" key="INVOICE_CONTENT_ID">
            <template slot-scope="scope">
              <span>{{ invoiceContent[scope.row.INVOICE_CONTENT_ID - 1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发票状态" v-if="otherData.status == 6" width="100" key="STATUS">
            <template slot-scope="scope">
              <span>{{ statusList[scope.row.STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">{{ [1, 4].includes(otherData.status) ? '审核' : '查看详情' }}
              </el-button>
              <el-button type="text" @click="showBindOrder(scope.row)">查看关联订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <VInvoiceForm v-if="invoiceFormVisible" :invoiceFormVisible="invoiceFormVisible" :detailData="detailData"
      :source="'detail'" @closeDialog="getDialogStatus">
    </VInvoiceForm>
    <el-dialog title="关联订单" :visible.sync="dialogVisible" @close="dialogVisible = false" width="65%" center
      :close-on-click-modal="false">
      <el-table :data="dialogTableData" border stripe ref="dialogTableData">
        <el-table-column label="订单ID" prop="ORDER_ID"></el-table-column>
        <el-table-column label="订单编号" prop="ORDER_CODE"></el-table-column>
        <el-table-column label="客户名称">
          <template slot-scope="scope">
            <span>{{ scope.row.TC_NAME || scope.row.SUPPLIER_CLIENT_NAME }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收总金额" prop="REAL_TOTAL_SUPPLIER_FEE"></el-table-column>
        <el-table-column label="实收总重量" prop="REAL_TOTAL_WEIGHT"></el-table-column>
        <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getInvoiceDetail, getInvoiceBindOrders } from 'api/invoice';
import VInvoiceForm from '../financeCenter/invoiceForm';

export default {
  components: {
    VInvoiceForm,
  },
  props: {
    // 父组建传递的弹出框状态值
    tableData: {
      type: Array,
      default: null,
    },
    otherData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      statusList: [
        '发票已拒绝',
        '审核中',
        '未开票',
        '已开票',
        '退票审核中',
        '已退票',
        '已收款',
        '未收款',
      ],
      invoiceTypeList: ['专票', '普票'],
      invoiceContent: ['明细', '汇总'],
      invoiceFormVisible: false,
      detailData: {},
      dialogTableData: [],
      dialogVisible: false,
    };
  },
  methods: {
    async detail(row) {
      await getInvoiceDetail({ ID: row.ID }).then((res) => {
        this.detailData = {
          ...res[0],
          status: this.otherData.status,
          INVOICE_NUM: res[0].INVOICE_NUM == 0 ? '' : res[0].INVOICE_NUM,
        };
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
      await getInvoiceBindOrders({ ID: row.ID }).then((res) => {
        this.detailData.orderList = res.LIST.map((item) => item.ORDER_ID);
        this.detailData.isSupplierClient = res.IS_SUPPLIER_CLIENT;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
      this.invoiceFormVisible = true;
    },
    // 获取来自发票模态框的状态响应值
    getDialogStatus(res) {
      this.invoiceFormVisible = false;
    },
    showBindOrder(row) {
      getInvoiceBindOrders({ ID: row.ID }).then((res) => {
        this.dialogTableData = res.LIST;
        this.dialogVisible = true;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
  },
  watch: {
    // 监听--向父组件更新状态值
    invoiceFormVisible(newVal, oldVal) {
      this.$emit('closeDialog', newVal);
    },
    tableData() {
      this.$nextTick(() => {
        this.$refs.tableData.doLayout();
      });
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financeCenter/invoiceListTable.vue